export const normalizePetStats = (stats) => {
  if (!stats) return {};

  if (typeof stats === "string") {
    try {
      return JSON.parse(stats);
    } catch {
      return {};
    }
  }

  return stats;
};

export const formatActiveTime = (timeMs = 0) => {
  const seconds = Math.floor(timeMs / 1000);
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}m ${rest}s`;
};

export const getPetPowerups = (stats) => {
  const safeStats = normalizePetStats(stats);

  return [
    { label: "🔗", value: safeStats.visits || 0 },
    { label: "👆", value: safeStats.clicks || 0 },
    { label: "⚡", value: safeStats.scrolls || 0 },
    { label: "🕒", value: formatActiveTime(safeStats.timeMs || 0) },
    { label: "Lift Drags", value: safeStats.drags || 0 },
    { label: "Wild Jumps", value: safeStats.jumps || 0 },
  ];
};
